<template>
  <div class="home">
    <a-row :gutter="[16, 16]">
      <a-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" :xxl="24"
        v-for="dorm in dorms" :key="dorm.dormId">
        <Dorm :dorm="dorm"/>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import Dorm from "@/components/dorm/Dorm.vue";
import httpClient from "@/utils/httpClient";

export default {
  name: "Nodes",
  data() {
    return {
      dorms: [],
      loadingDorms: true
    };
  },
  components: {
    Dorm
  },
  mounted() {
    this.$emit("loadedView");
    this.loadDorms();
  },
  methods: {
    loadDorms() {
      this.loadingDorms = true
      httpClient
          .get(`/admin/dorms`)
          .then((response) => {
            this.dorms = response;
          }).catch(() => {
        this.$message.error("Wystąpił błąd z pobraniem listy węzłów!")
      }).finally(() => {
        this.loadingDorms = false
      })
    },

    goTo(obj) {
      if (this.$route.name !== obj.name) {
        this.$router.push(obj);
      }
    },
  },
};
</script>
